<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.REFERENCE"
                        label="REFERENCE"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.DESC_NL"
                        label="DESC_NL (*)"
                        :rules="[() => !!$store.state.batteriesEditedItem.DESC_NL]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.DESC_FR"
                        label="DESC_FR (*)"
                        :rules="[() => !!$store.state.batteriesEditedItem.DESC_FR]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.TYPE"
                        label="TYPE (*)"
                        :rules="[() => !!$store.state.batteriesEditedItem.TYPE]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="2"
                    md="2"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.COMPATIBILITY"
                        label="COMPATIBILITY (*)"
                        :rules="[() => !!$store.state.batteriesEditedItem.COMPATIBILITY]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.ACCESSORIES"
                        label="ACCESSORIES"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.BATTERY_MODULE"
                        label="BATTERY_MODULE"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.batteriesEditedItem.BATTERY_ID"
                        label="SMA_BATTERY_ID"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireBatteries",
		data: function () {
			return {
            }
        }
    }
</script>
